import { CountryCode } from "libphonenumber-js";

export function phoneStartWithIndicative(internationalPrefix: string, phone: string = ""): boolean {
	const prefixNumber = internationalPrefix.replace("+", "");
	return phone.startsWith(prefixNumber);
}

/**
 * La región ISO que necesita libphonenumber para un `country_code` de la plataforma. Casi todos
 * ya lo son (UY, PY, CO, PE, BO); Casas y Más usa `CYM` y es Uruguay (INF-2226). Sin esto,
 * `getCountryCallingCode("CYM")` tira «Unknown country» y se cae el header y la ficha.
 */
const REGION_POR_COUNTRY_CODE: Record<string, CountryCode> = { CYM: "UY" };

export const phoneRegion = (country_code: string): CountryCode =>
	REGION_POR_COUNTRY_CODE[country_code] ?? (country_code as CountryCode);
